import { render, staticRenderFns } from "./IdentificationDocumentItem.vue?vue&type=template&id=2e975690&"
import script from "./IdentificationDocumentItem.vue?vue&type=script&lang=js&"
export * from "./IdentificationDocumentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports